import { render } from "./SurveyPageSingleDelivery.vue?vue&type=template&id=1d93ae84&scoped=true"
import script from "./SurveyPageSingleDelivery.vue?vue&type=script&lang=js"
export * from "./SurveyPageSingleDelivery.vue?vue&type=script&lang=js"

import "./SurveyPageSingleDelivery.vue?vue&type=style&index=0&id=1d93ae84&scoped=true&lang=css"

import exportComponent from "/home/devops/vsts-agent/_work/20/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d93ae84"]])

export default __exports__